// extracted by css-extract-rspack-plugin
export default {"LanguageCircleIndicator":"LanguageCircle-module__LanguageCircleIndicator__GgHY6Sz"};